<script>
    import {Bar} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {hexToRgba} from '@coreui/coreui/dist/js/coreui-utilities'

    export default {
        components: {
            hexToRgba,
            CustomTooltips
        },
        extends: Bar,
        mounted() {
            this.renderChart(
                {
                    labels: ['2017', '2018'],
                    datasets: [
                        {
                            label: 'CULTURA',
                            backgroundColor: hexToRgba('#ff00a4', 70),
                            fill: true,
                            data: ['', '', 18195]
                        },
                        {
                            label: 'DEPORTE',
                            backgroundColor: hexToRgba('#ff003f', 70),
                            fill: true,
                            data: ['', '', 3067]
                        },
                        {
                            label: 'DESARROLLO SOCIAL',
                            backgroundColor: hexToRgba('#1cff37', 70),
                            fill: true,
                            data: ['', '', 8772]
                        },
                        {
                            label: 'EDUCACIÓN',
                            backgroundColor: hexToRgba('#00a7ff', 70),
                            fill: true,
                            data: ['', '', 104129]
                        },
                        {
                            label: 'EXTENSIÓN',
                            backgroundColor: hexToRgba('#ff8d00', 70),
                            fill: true,
                            data: ['', '', 1131]
                        }
                    ]
                },
                {
                    responsive: true,
                    scales: {
                        yAxes: [{
                            stacked: false,
                        }]
                    },
                    maintainAspectRatio: true,
                    tooltips: {
                        enabled: false,
                        custom: CustomTooltips,
                        intersect: false,
                        mode: 'index',
                        position: 'nearest',
                        callbacks: {
                            labelColor: function (tooltipItem, chart) {
                                return {backgroundColor: chart.data.datasets[tooltipItem.datasetIndex].backgroundColor}
                            }
                        }
                    }
                }
            )
        }
    }
</script>
